import { render, staticRenderFns } from "./biologicalAgeHeart.vue?vue&type=template&id=0500709b&scoped=true&"
import script from "./biologicalAgeHeart.vue?vue&type=script&lang=js&"
export * from "./biologicalAgeHeart.vue?vue&type=script&lang=js&"
import style0 from "./biologicalAgeHeart.vue?vue&type=style&index=0&id=0500709b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0500709b",
  null
  
)

export default component.exports